import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-layout-simple-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class LayoutSimpleFooterComponent implements OnInit {
  public year: number = new Date().getFullYear();

  constructor() {}

  ngOnInit() {}
}
